/* cart-upsell-routine — a szekciobol kiemelve 2026-07-26.
   Delegalt esemenykezeles + __cartUpsellRoutineLoaded guard -> tobbszor elhelyezheto. */
(function(){
  if (window.__cartUpsellRoutineLoaded) return;
  window.__cartUpsellRoutineLoaded = true;

  function setBtn(btn, disabled, text) {
    if (!btn) return;
    btn.disabled = disabled;
    if (text) btn.textContent = text;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function(r){
      if (!r.ok) throw new Error('Product fetch failed: ' + handle);
      return r.json();
    });
  }

  function addVariant(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity || 1 }]
      })
    }).then(function(r){
      if (!r.ok) throw new Error('Cart add failed');
      return r;
    });
  }


  /* ── SOFT FRISSITES a teljes lap-ujratoltes helyett (2026-07-26) ──────────────────────
     Lasd a fajl tetejen: az ot `location.reload()` a drawer bezarasat okozta minden
     hozzaadasnal. A `renderContents` a Dawn sajat utja: frissiti a `#CartDrawer` tartalmat
     es nyitva hagyja. Fallback minden agon a regi `reload()`, hogy a megjelenitett kosar
     SOSE terjen el a valositol. */
  function refreshCart() {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.classList.contains('active') || typeof d.renderContents !== 'function') {
      window.location.reload();
      return Promise.resolve();
    }
    var ids = (typeof d.getSectionsToRender === 'function')
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { d.renderContents({ sections: sections }); })
      .catch(function () { window.location.reload(); });
  }

  function addProductByHandle(handle) {
    return fetchProduct(handle).then(function(product){
      return addVariant(product.variants[0].id, 1);
    });
  }

  document.addEventListener('click', function(e){
    var addBtn = e.target.closest('[data-cup-add]');
    if (addBtn) {
      e.preventDefault();
      var addHandle = addBtn.getAttribute('data-cup-add');
      var originalText = addBtn.textContent;
      var T = window.dsT || {};
      setBtn(addBtn, true, T.adding_dots || 'Hozzáadás...');
      addProductByHandle(addHandle)
        .then(refreshCart)
        .catch(function(err){
          console.error(err);
          setBtn(addBtn, false, originalText || T.add_btn || 'Hozzáadom');
          alert(T.error_retry || 'Hiba történt. Próbáld újra!');
        });
      return;
    }

    // ⛔ 2026-08-06: EZ AZ AG MAR NEM FUT, es NE IS ELESZTSD UJRA a `data-cup-swap`
    // markup visszarakasaval. A csere `addVariant(variantId, 1)`-gyel adja vissza a
    // tetelt, selling_plan NELKUL, tehat egy ELOFIZETESES kosarban NEMAN megszunteti az
    // elofizetest, es vele a huseg-arat, az ingyen szallitast es a 8%-os pontot. A vevo
    // ebbol semmit nem lat. Ha valaha megis kell csere, a selling_plan_allocation-t at
    // KELL vinni az uj tetelre, es a gombnak ki kell mondania, mi tortenik.
    var swapBtn = e.target.closest('[data-cup-swap]');
    if (swapBtn) {
      e.preventDefault();
      var singleHandle = swapBtn.getAttribute('data-cup-swap');
      var bundleHandle = swapBtn.getAttribute('data-cup-bundle');
      var originalSwapText = swapBtn.textContent;
      setBtn(swapBtn, true, 'Csere...');
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var singleItem = cart.items.find(function(item){ return item.handle === singleHandle; });
          if (!singleItem) throw new Error('Single item not found');
          return fetchProduct(bundleHandle).then(function(bundleProduct){
            var updates = {};
            updates[singleItem.key] = 0;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function(){ return addVariant(bundleProduct.variants[0].id, 1); });
          });
        })
        .then(refreshCart)
        .catch(function(err){
          console.error(err);
          setBtn(swapBtn, false, originalSwapText || 'Kérem így');
          alert((window.dsT || {}).error_retry || 'Hiba történt. Próbáld újra!');
        });
      return;
    }

    var dualBtn = e.target.closest('[data-cup-swap-dual]');
    if (dualBtn) {
      e.preventDefault();
      var dualBundleHandle = dualBtn.getAttribute('data-cup-bundle');
      var originalDualText = dualBtn.textContent;
      setBtn(dualBtn, true, 'Csere...');
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var stampItem = cart.items.find(function(item){ return item.handle === 'dermastamp'; });
          var centellaItem = cart.items.find(function(item){ return item.handle === 'centella'; });
          if (!stampItem || !centellaItem) throw new Error('Items not found');
          return fetchProduct(dualBundleHandle).then(function(bundleProduct){
            var updates = {};
            updates[stampItem.key] = 0;
            updates[centellaItem.key] = 0;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function(){ return addVariant(bundleProduct.variants[0].id, 1); });
          });
        })
        .then(refreshCart)
        .catch(function(err){
          console.error(err);
          setBtn(dualBtn, false, originalDualText || 'Cserélem');
          alert((window.dsT || {}).error_retry || 'Hiba történt. Próbáld újra!');
        });
      return;
    }

    var routineBtn = e.target.closest('[data-rutin-add]');
    if (routineBtn) {
      e.preventDefault();
      var routineHandle = routineBtn.getAttribute('data-rutin-add');
      var itemEl = routineBtn.closest('.rutin__item');
      setBtn(routineBtn, true, '✓');
      addProductByHandle(routineHandle)
        .then(function(){
          if (itemEl) {
            itemEl.classList.add('rutin__item--removing');
            setTimeout(refreshCart, 350);   /* a kis eltuno-animacio vegen */
          } else {
            refreshCart();
          }
        })
        .catch(function(err){
          console.error(err);
          setBtn(routineBtn, false, '+');
          alert((window.dsT || {}).error_retry || 'Hiba történt. Próbáld újra!');
        });
      return;
    }
  });
})();

/* ── CART-UPSELL-V2 (2026-10-18): variant-ID-s hozzaadas + a teljes-rutin ajandek szinkronja ──────────
   A snippets/cart-upsell-v2.liquid gombjai `data-cup2-add="<variant id>"`-t hordoznak (nincs handle-fetch).
   AJANDEK: arcos stamp-csomag + alap rutin + Centella egy kosarban -> a Biodance maszk `_ds_gift` sorral
   bekerul (ingyenesseget a DiscountAutomaticNode/2288938123596 adja), hianyos rutinnal kikerul. Ugyanaz a
   szabaly, mint a snippetben (bonus). Csak nyitott drawerben vagy a /cart oldalon fut (ahol a vevo latja),
   es ha a vevo maga torolte a maszkot, ugyanabban a kosarban nem tesszuk vissza. */
(function () {
  if (window.__cup2Loaded) return;
  window.__cup2Loaded = true;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT = 57449221882188;
  var ID = { stamp: 15428227170636, kura: 16205686931788, bundle: 15677100982604, cen: 15674917814604, alap: 16176798662988 };
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  var busy = false;

  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function drawerOpen() { var d = document.querySelector('cart-drawer'); return !!(d && d.classList.contains('active')); }
  function refresh() {
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active') && typeof d.renderContents === 'function') {
      var ids = typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      return fetch(ROOT + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (s) { d.renderContents({ sections: s }); })
        .catch(function () { location.reload(); });
    }
    location.reload();
    return Promise.resolve();
  }
  function giftWanted(cart) {
    var face = false, alap = false, cen = false;
    cart.items.forEach(function (i) {
      if (i.product_id === ID.kura || i.product_id === ID.bundle || (i.product_id === ID.stamp && !i.selling_plan_allocation)) face = true;
      if (i.product_id === ID.bundle || i.product_id === ID.cen) cen = true;
      if (i.product_id === ID.alap) alap = true;
    });
    return face && alap && cen;
  }
  function declinedKey(cart) { return 'cup2-gift-out-' + cart.token; }
  function sync() {
    if (busy || !(drawerOpen() || onCartPage)) return;
    busy = true;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var gift = null, anyGift = false;
      cart.items.forEach(function (i) {
        if (i.variant_id === GIFT) { anyGift = true; if (i.properties && i.properties._ds_gift) gift = i; }
      });
      var want = giftWanted(cart), k = declinedKey(cart), st = window.sessionStorage;
      var added = false; try { added = st.getItem(k) === 'added'; } catch (e) {}
      if (want && !anyGift) {
        if (added) return null;                 /* a vevo kivette: nem erolteljuk vissza */
        try { st.setItem(k, 'added'); } catch (e) {}
        return post('cart/add.js', { items: [{ id: GIFT, quantity: 1, properties: { _ds_gift: '1' } }] }).then(refresh);
      }
      if (!want && gift) {
        try { st.removeItem(k); } catch (e) {}
        return post('cart/change.js', { id: gift.key, quantity: 0 }).then(refresh);
      }
      if (!want) { try { st.removeItem(k); } catch (e) {} }
      return null;
    }).catch(function (e) { console.error('[cup2] gift sync', e); })
      .then(function () { busy = false; });
  }
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(sync, 250); }

  /* data-cup2-add="<id>[,<id>...]": UJ sorok (a meglevokhoz es a selling_plan-jukhoz nem nyul).
     data-cup2-rm="<sor-kulcs>": a BF-csempe (cart-rbf) kapcsolo-fele, a sort kiveszi (mennyiseg 0).
     Amig egy keres fut, a teljes csempe-blokk all (dupla koppintas = dupla tetel ellen). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cup2-add],[data-cup2-rm]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-ckr]');
    if (b.disabled || (box && box.classList.contains('is-busy'))) return;
    var txt = b.textContent; b.disabled = true; b.setAttribute('aria-busy', 'true');
    if (box) box.classList.add('is-busy');
    var rm = b.getAttribute('data-cup2-rm');
    var req = rm ? post('cart/change.js', { id: rm, quantity: 0 })
      : post('cart/add.js', { items: b.getAttribute('data-cup2-add').split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; }) });
    req.then(refresh)
      .catch(function (err) {
        console.error(err); b.disabled = false; b.removeAttribute('aria-busy');
        if (!b.hasAttribute('data-ckr-keep')) b.textContent = txt;
        if (box) box.classList.remove('is-busy');
        alert((window.dsT || {}).error_retry || 'Hiba történt. Próbáld újra!');
      });
  });

  /* a /cart oldalon a Dawn mennyiseg-valtasa nem rendereli ujra ezt a szekciot: itt frissitjuk */
  function refreshCartSection() {
    var host = document.querySelector('.cup-section');
    if (!host || !host.id) return;
    var sid = host.id.replace(/^shopify-section-/, '');
    fetch(ROOT + 'cart?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.getElementById(host.id) || doc.querySelector('.cup-section');
        if (fresh) host.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }
  /* a `const PUB_SUB_EVENTS` nem window-property: a globalis lexikai nevet nezzuk, betoltes utan */
  function hookPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (onCartPage) refreshCartSection(); later(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookPubSub); else hookPubSub();
  /* a drawer AJAX-szal rendereli ujra az ajanlatot: ha uj .ck jelenik meg, ellenorzunk */
  if (window.MutationObserver) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('[data-ck]') || n.querySelector('[data-ck]'))) { later(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.querySelector('[data-ck]')) later();
})();
